import React, { ReactNode } from 'react';
import QrCode from 'react-qr-code';

import MobileAppButtons from 'src/components/blocks/MobileAppBanner/MobileAppButtons';
import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';
import { PhoneFrame } from 'src/components/elements/PhoneFrame';
import { LOGO, S3_URL } from 'src/components/pages/loyalty/SharingPage/constants';

import { getIsMobileUserAgent } from 'src/helpers/getIsMobileUserAgent';

import styles from './MobileAppBanner.scss';

const isMobileUserAgent = getIsMobileUserAgent(
  typeof window !== 'undefined' ? window.navigator.userAgent : ''
);

type Props = {
  picture: 'planet' | 'solar-coins';
  title?: ReactNode;
  description?: ReactNode;
  qrCodeLink?: string;
};

const MobileAppBanner = (props: Props) => {
  const {
    title = (
      <>
        <span className={styles.subtitle}>Not using</span>
        <br />
        our app&nbsp;<span className={styles.subtitle}>yet?</span>
      </>
    ),
    description = (
      <span>
        Install the app and receive <br />
        Planet reward for your activity
      </span>
    ),
    picture,
    qrCodeLink = 'https://slr.onelink.me/gEAA/qw743goy',
  } = props;

  const handleDownloadApp = () => {
    window.open('https://slr.onelink.me/gEAA/qw743goy', '_blank');
  };

  const pictureSrcName =
    picture === 'planet' ? `${S3_URL}referral/planet` : `${S3_URL}solar_cash_landing/solar_coins`;

  return (
    <div className={styles.rootContainer}>
      <div className={styles.container}>
        <div className={styles.textBlock}>
          <FadeIn className={styles.title} delay={0.2}>
            {title}
          </FadeIn>
          <FadeIn delay={0.4} className={styles.description}>
            {description}
          </FadeIn>

          {!isMobileUserAgent && <MobileAppButtons downloadLink={qrCodeLink} />}
        </div>

        <div className={styles.mobAppContainer}>
          <PhoneFrame>
            <div className={styles.phoneContent}>
              {isMobileUserAgent ? (
                <picture>
                  <source srcSet={`${pictureSrcName}.avif`} type="image/avif" />
                  <source srcSet={`${pictureSrcName}.webp`} type="image/webp" />
                  <img src={`${pictureSrcName}.jpg`} className={styles.picture} alt="" />
                </picture>
              ) : (
                <>
                  <img className={styles.phoneLogo} src={LOGO.DESKTOP} alt="logo" />
                  <QrCode value={qrCodeLink} className={styles.qrCode} />
                </>
              )}
            </div>
          </PhoneFrame>
          {isMobileUserAgent && (
            <FadeIn className={styles.downloadButtonContainer} delay={0.6}>
              <GradientButton onClick={handleDownloadApp} className={styles.downloadButton}>
                Download App
              </GradientButton>
            </FadeIn>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileAppBanner;
